import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch2, fetch3, fetch4, fetch5, fetch8 } from "../commonApis/commonApis";
import { useDispatch } from "react-redux";
import { addReturnToShipper, setReturnToShipperList } from "../features/returnToShipper/returnToShipperSlice";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useFetchReturnToShipperData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  const dispatch = useDispatch()
  return useQuery({
    queryKey: ["returnToShipper"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/return-to-shipper/lm?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }
      dispatch(setReturnToShipperList(res.data))

      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useReturnToShipperMutation = () => {
   const dispatch = useDispatch()
  return useMutation({
    mutationFn: async (payload: any) => {

      const res: ApiResponse = await fetch4(
        `${url}/api/return-to-shipper/create/lm`,
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res;
    },
    onSuccess: (data: any) => {
      console.log("✅ Return to shipper Genrated successfully:", data);
      dispatch(addReturnToShipper(data))
      return data;
    },
    onError: (error: any) => {
      console.error("Return to shipper Genrated request failed:", error.message);
    },
  });
};

// export const useFetchReturnToShipperDetails = (id: any) => {
//   return useQuery({
//     queryKey: ["returnToShipper"],
//     queryFn: async () => {
//       const res = await fetch3(`${url}/api/return-to-shipper/detailsById/${id}`, "get");

//       if (!res || !res.data) {
//         return res.message;
//       }

//       return res.data;
//     },
//     staleTime: 1000 * 60 * 5,
//   });
// };

export const useFetchReturnToShipperDetails = (
  page: number,
  limit: number,
  searchFor: string,
  returnId: string
) => {
  return useQuery({
    queryKey: ["returnToShipper", page, limit, searchFor, returnId],
    queryFn: async () => {
      if (!returnId) {
        return null;
      }

      const res = await fetch3(
        `${url}/api/return-to-shipper/detailsById/${returnId}?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: !!returnId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useAssignDriverMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {

      const res: ApiResponse = await fetch4(
        `${url}/api/return-to-shipper/assign/driver`,
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Driver Assign successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Driver Assign request failed:", error.message);
    },
  });
};

export const useReturnToShipperDocMutation = () => {
    return useMutation({
        mutationFn: async (payload: any) => {
            const res: ApiResponse = await fetch8(`${url}/api/return-to-shipper/${payload?.id}`, 'PATCH', payload);

            // Manually throw error if success is false
            if (!res.success) {
                throw res.message || 'Something went wrong';
            }

            return res;
        },
        onSuccess: (res: any) => {
            console.log('✅ Notification Created successfully:', res);
            return res;
        },
        onError: (error: any) => {
            console.error('❌ Notification create request failed:', error.message);
        }
    });
};
